import { boolean, Infer, string, type } from "superstruct";
import { isStruct } from "../utils/isStruct";
import { TimestampStruct } from "./Timestamp";

export const WebhookConfigStruct = type({
  id: string(),
  organizationId: string(),
  /**
   * The URL to send webhook events to.
   */
  url: string(),
  /**
   * Bearer token for authentication. Auto-generated when webhook is created.
   */
  bearerToken: string(),
  /**
   * Whether the webhook is enabled.
   */
  enabled: boolean(),
  createdAt: TimestampStruct,
  updatedAt: TimestampStruct,
});

/**
 * Webhook configuration for an organization.
 * @interface
 * @category Webhook
 */
export type WebhookConfig = Infer<typeof WebhookConfigStruct>;

export function isWebhookConfig(obj: unknown): obj is WebhookConfig {
  return isStruct(obj, WebhookConfigStruct, "WebhookConfig");
}
